import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetSubscriptionPrice = (planCode: string) => {
  const webshopService = useServices().webshopService;
  return useQuery({
    queryKey: ['subscriptionPrice', planCode],
    queryFn: () => webshopService.getSubscriptionPrice(planCode),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
